import axios from 'axios';

import { DASHBOARD } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

// LOAD USER
export const buscarDashboard = (tipo) => async dispatch => {
    try {
        if(tipo){
            await dispatch(changeLoader(true));
            const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/dashboard/${tipo}`);

            await dispatch({
                type: DASHBOARD.OBTENER,
                payload: res.data.datos
            });
        }else{
            await dispatch({
                type: DASHBOARD.OBTENER,
                payload: null
            });
        }
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

/* Las tarjetas del dashboard se cargan de forma independiente (cada una con su propio
   estado de carga/error) en vez del loader global, para que una tarjeta lenta o caída
   no bloquee ni tire una alerta sobre el resto del dashboard. */
export const buscarProyectosActivos = () => async dispatch => {
    try {
        await dispatch({ type: DASHBOARD.PROYECTOS_ACTIVOS_CARGANDO });

        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/dashboard/proyectos_activos`);

        await dispatch({
            type: DASHBOARD.PROYECTOS_ACTIVOS,
            payload: res.data?.activos ?? null
        });
    } catch (error) {
        await dispatch({ type: DASHBOARD.PROYECTOS_ACTIVOS_ERROR });
    }
}

export const buscarVentasPeriodos = () => async dispatch => {
    try {
        await dispatch({ type: DASHBOARD.VENTAS_PERIODOS_CARGANDO });

        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/dashboard/ventas_periodos`);

        await dispatch({
            type: DASHBOARD.VENTAS_PERIODOS,
            payload: res.data || null
        });
    } catch (error) {
        await dispatch({ type: DASHBOARD.VENTAS_PERIODOS_ERROR });
    }
}

export const buscarVentas30Dias = () => async dispatch => {
    try {
        await dispatch({ type: DASHBOARD.VENTAS_30_DIAS_CARGANDO });

        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/dashboard/ventas_30_dias`);

        await dispatch({
            type: DASHBOARD.VENTAS_30_DIAS,
            payload: Array.isArray(res.data) ? res.data : []
        });
    } catch (error) {
        await dispatch({ type: DASHBOARD.VENTAS_30_DIAS_ERROR });
    }
}

export const buscarPorCobrar = () => async dispatch => {
    try {
        await dispatch({ type: DASHBOARD.POR_COBRAR_CARGANDO });

        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/dashboard/por_cobrar`);

        await dispatch({
            type: DASHBOARD.POR_COBRAR,
            payload: res.data || null
        });
    } catch (error) {
        await dispatch({ type: DASHBOARD.POR_COBRAR_ERROR });
    }
}